let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hm52u")).then(() => parcelRequire('ewHJ9'));